export var SlidingDirections;
(function (SlidingDirections) {
    SlidingDirections["Next"] = "Next";
    SlidingDirections["Previous"] = "Previous";
})(SlidingDirections || (SlidingDirections = {}));
